import { LOGO, SEAL, ALLY_ICON } from './Footer.utils.js';
import styles from './Footer.module.scss';
import Image from 'Nori/Image';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import ContainerXL from 'Nori/Container/ContainerXL';
import BrandFooter from 'Custom/Footer/BrandFooter';
import MainNavigation from 'Custom/Footer/Navigation';
import AltNavigation from 'Custom/Footer/AltNavigation';
import { FOOTER_CONTENT } from 'Custom/Footer/Footer.utils';

const CookieButton = dynamic(() => import('./CookieButton'), { ssr: false });

const NavigationVariants = {
  main: MainNavigation,
  alternative: AltNavigation,
};

const ContainerVariants = {
  main: ContainerXL,
  alternative: ContainerXL,
};

const Footer = ({
  basic = false,
  jobCode,
  content = FOOTER_CONTENT,
  showFooterNav = false,
  hideBrandFooter = false,
}) => {
  const Navigation =
    NavigationVariants[content.navigationVariant] || NavigationVariants.main;
  const FooterContainer =
    ContainerVariants[content.navigationVariant] || ContainerVariants.main;

  return (
    <footer data-qa-tag="site-footer">
      {!basic && !hideBrandFooter && content.showBrandFooter && <BrandFooter data-qa-tag="footer-brand" />}
      {(!basic || (basic && showFooterNav)) && (
        <Navigation variant={content.navigationVariant} data-qa-tag="footer-navigation" />
      )}

      <section className={styles.secondSection} data-qa-tag="footer-second-section">
        <FooterContainer data-qa-tag="footer-container">
          <div className={styles.sectionWraper} data-qa-tag="footer-section-wrapper">
            <div className={styles.brandLogoContainer} data-qa-tag="footer-brand-logo-container">
              <span className={styles.brandLogo} data-qa-tag="footer-brand-logo">
                <Image
                  data-qa-tag="footer-logo-image"
                  src={LOGO}
                  width={215}
                  height={32}
                  alt={content.altLogoOrganon}
                />
              </span>
            </div>

            <ul className={styles.navList} data-qa-tag="footer-nav-list">
              <li data-qa-tag="footer-privacy-item">
                <Link
                  data-qa-tag="footer-privacy-link"
                  href="https://www.organon.com/privacy/"
                  target="_blank"
                  rel="noopener"
                  data-design-type="clickAction"
                  data-design-category="footer_ref_vd"
                  data-design-action="Link"
                  data-design-nori_id="Footer"
                  data-design-module_name="Footer"
                  data-design-module_no="00"
                  {...content.navList.privacyLink}
                />
              </li>
              <li>
                <Link
                  data-qa-tag="footer-terms-link"
                  href="https://www.organon.com/terms-of-use/"
                  target="_blank"
                  rel="noopener"
                  data-design-type="clickAction"
                  data-design-category="footer_ref_vd"
                  data-design-action="Link"
                  data-design-nori_id="Footer"
                  data-design-module_name="Footer"
                  data-design-module_no="00"
                  {...content.navList.termsLink}
                />
              </li>
              <li>
                <CookieButton data-qa-tag="footer-cookies-button" {...content.navList.cookiesButton} />
              </li>
              <li>
                <Link
                  data-qa-tag="footer-site-map-link"
                  href="/site-map/"
                  data-design-category="footer_ref_vd"
                  data-design-type="clickAction"
                  data-design-action="Link"
                  data-design-nori_id="Footer"
                  data-design-module_name="Footer"
                  data-design-module_no="00"
                  {...content.navList.siteMapLink}
                />
              </li>
            </ul>
          </div>
          <div className={styles.copySection} data-qa-tag="footer-copy-section">
            <div className={styles.copyright} data-qa-tag="footer-copyright">
              <p data-qa-tag="footer-copyright-text">
                {`© ${new Date().getFullYear()} ${content.copyright} `}
                <span className="job-code" data-qa-tag="footer-job-code">{jobCode}</span>
              </p>
            </div>
            <div className={styles.logoSection} data-qa-tag="footer-logo-section">
              <Link
                data-qa-tag="footer-seal-link"
                href="https://privacy.truste.com/privacy-seal/validation?rid=1ee67517-0029-4dd0-86b0-1262f41e225e"
                target="_blank"
                rel="noopener"
                className={styles.sealIcon}
              >
                <Image
                  data-qa-tag="footer-seal-image"
                  src={SEAL}
                  alt="TRUSTe"
                  width={143}
                  height={47}
                  data-design-type="clickAction"
                  data-design-category="footer_ref_vd"
                  data-design-action="Icon"
                  data-design-label="TRUSTe"
                  data-design-nori_id="Footer"
                  data-design-module_name="Footer"
                  data-design-module_no="00"
                />
              </Link>
              <Link
                data-qa-tag="footer-ally-link"
                href="https://www.levelaccess.com/organon/"
                target="_blank"
                rel="noopener"
                className={styles.allyIcon}
              >
                <Image
                  data-qa-tag="footer-ally-image"
                  src={ALLY_ICON}
                  width={119}
                  height={47}
                  alt="Accessibility icon"
                  data-design-type="clickAction"
                  data-design-category="footer_ref_vd"
                  data-design-action="Icon"
                  data-design-label="Accessibility icon"
                  data-design-nori_id="Footer"
                  data-design-module_name="Footer"
                  data-design-module_no="00"
                />
              </Link>
            </div>
          </div>
        </FooterContainer>
      </section>
    </footer>
  );
};

export default Footer;
